import {showErrorDialog, toggleLoadingDialog} from "@2d-front-monorepo/design-library";
import {PermitResult, Permits} from "@2d-front-monorepo/permits-business";
import {getHttpClient} from "./getHttpClient";
import {ReloadEntities, reloadPermits} from "./reloadPermits";

export async function toggleAutoRenewPermit(permit: PermitResult): Promise<void> {
	const httpClient = getHttpClient();

	try {
		toggleLoadingDialog(true);
		await httpClient.permits.setAutoRenew(permit.id, !Permits.isAutoRenewEnabled(permit));
		await reloadPermits(ReloadEntities.Permits);
	} catch (error) {
		showErrorDialog(error);
	} finally {
		toggleLoadingDialog(false);
	}
}
